export const distributor = {
  tableCol: {
    no: { en: 'No.', ko: '번호', fr: '' },
    name: { en: 'Name', ko: '이름', fr: '' },
    date: { en: 'Date', ko: '날짜', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
  },
  info: {
    distributor: { en: 'Distributor name', ko: '대리점명', fr: '' },
    type: { en: 'Type', ko: '유형', fr: '' },
    mainContact: { en: 'Main contact', ko: '대표 전화번호', fr: '' },
    contact: { en: 'Contact', ko: '전화번호', fr: '' },
    email: { en: 'Email', ko: '이메일', fr: '' },
    zipNum: { en: 'Zip num', ko: '우편번호', fr: '' },
    address: { en: 'Address', ko: '주소', fr: '' },
    time: { en: 'Timezone', ko: '타임존', fr: '' },
    manager: { en: 'Manager', ko: '담당자', fr: '' },
    registerDate: { en: 'Registration date', ko: '등록날짜', fr: '' },
    updateDate: { en: 'Update date', ko: '수정날짜', fr: '' },
    subList: { en: 'Sub list', ko: '서브 리스트', fr: '' },
    status: { en: 'Status', ko: '상태', fr: '' },
    // addSlaveOrganization: { en: 'Add sub-organization', ko: '하위 조직 추가', fr: '' },
    mgrEmail: { en: 'Manager email', ko: '담당자 이메일', fr: '' },
    mgrTel: { en: 'Manager Tel', ko: '담당자 번호', fr: '' },
    region: { en: 'Country', ko: '국가', fr: '' },
    city: { en: 'City', ko: '도시', fr: '' },
    distributorCode: { en: 'Distributor code', ko: '대리점 코드' },
    info: { en: 'ETC', ko: '기타', fr: '' },
  },
  drawer: {
    addSub: { en: 'Add Sub-Organization', ko: '하위 조직 추가', fr: '' },
    findSub: { en: 'Organization', ko: '조직', fr: '' },
  },
  select: {
    sub: { en: 'Select sub', ko: '하위조직 선택', fr: '' },
    organization: { en: 'Organization', ko: '조직', fr: '' },
  },
  title: {
    summary: { en: 'Organization Summary', ko: '조직 요약 정보', fr: '' },
  },
  button: {
    centralTargetEntity: { en: 'Select as CMS Organigation', ko: 'CMS 조직 등록', fr: '' },
  },
};
